import { ODataSelect } from "@iconics/core";

export interface INode
{
    Id: number;
    Name: string;
    Deleted: boolean;
    CustomNodeID: string;
    DisplayName: string;
    PartitionKey: number;
    Parent_ID: number;
    HierarchyNodeConfigurationEntityId: number;
    FallbackNode_ID: number;
    IsEnabled: number;
    SortOrder: string;
    TimeZone: string;
    TimeZoneType: number;
    TimeZoneDST: number;
    ImageURI: string;
    '@odata.etag': string;
}

export interface IOntologyNode
{
    Node_Id: string;
    OntologyNode_ID: string;
    Ontology_Name: string;
    OntologyNode_Name: string;
}

export interface IOntologyNodeParameter
{
    Id: string;
    Value: string;
    ValueType: string;
    IsEnabled: string;
    Node_ID: string;
    Parameter_ID: string;
    Solution_ID: string;
    '@odata.etag': string;
}

export class SolutionParameter extends ODataSelect
{
    public Id = "";
    public Name = "";
    public IsEnabled = "";

    override toSelect(): string
    {
        return ''
    }
}

export class DataPoint extends ODataSelect
{
    public DataPoint_Id = "";
    public Name = "";
    public DisplayName = "";
    public DataPointType = 0;
    public IsEnabled = "";
}

export class Solution extends ODataSelect
{
    public Id = '';
    public Ontology_ID = '';
    public Name = '';
    public DisplayName = '';
    public IsEnabled = '';
}

export class Ontology extends ODataSelect
{
    public Id = '';
    public Name = '';
    public DisplayName = '';
    public IsEnabled = '';
}

export class OntologyNode2 extends ODataSelect
{
    public Id = '';
    public Parent_ID: string | null = '';
    public Name = '';
    public IsEnabled = '';
}
